import React from 'react';
import { useTranslation } from 'react-i18next';

const StakeholderHeaderTipContent = () => {
  const { t } = useTranslation();
  return (
    <p>
      {t('tipOrganizationStakeholder')}
    </p>
  );
};

export default StakeholderHeaderTipContent;
